/* eslint-disable no-restricted-syntax */
import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import YandexShare from 'react-yandex-share';

import styles from './styles.module.scss';

const ShareButtons = ({
	theme,
	customSocialButtonsOrder = 'vkontakte,odnoklassniki,whatsapp,telegram',
	customClassName = '',
	imageSrc,
	tabIndex = 0
}) => {
	const [shareButtonContainer, setShareButtonContainer] = useState(null);
	const shareButtonsRef = useRef(null);

	const shareButtonsCx = cx(
		styles.wrap,
		styles[`theme_${theme}`],
		styles[customClassName]
	);

	useEffect(() => {
		if ([0, -1].includes(tabIndex) && shareButtonContainer) {
			const anchors = shareButtonContainer.querySelectorAll('a');
			for (const [index, anchor] of anchors.entries()) {
				anchor.tabIndex = tabIndex;
				if (index === 0 && tabIndex === 0) {
					anchor.focus();
				}
			}
		}
	}, [tabIndex]);

	useEffect(() => {
		setShareButtonContainer(shareButtonsRef?.current);
	}, [shareButtonsRef]);

	return (
		<div className={shareButtonsCx} ref={shareButtonsRef}>
			{shareButtonContainer && (
				<YandexShare
					key={imageSrc}
					theme={{
						bare: true,
						lang: 'ru',
						services: customSocialButtonsOrder
					}}
					content={
						!!imageSrc && {
							url: imageSrc
						}
					}
					hooks={{
						onready: () => {
							const anchors = shareButtonContainer.querySelectorAll('a');
							const elementsInOrder = customSocialButtonsOrder.split(',');
							for (const [index, anchor] of anchors.entries()) {
								const socialName = elementsInOrder[index];
								anchor.tabIndex = -1;
								anchor.ariaLabel = `Поделиться: ${socialName}`;
							}
						}
					}}
				/>
			)}
		</div>
	);
};

ShareButtons.propTypes = {
	theme: PropTypes.oneOf(['horizontal']),
	customSocialButtonsOrder: PropTypes.string,
	customClassName: PropTypes.string,
	imageSrc: PropTypes.string,
	tabIndex: PropTypes.number
};

export default ShareButtons;
